export default "__VITE_ASSET__CmKTEgVb__"